import { render, staticRenderFns } from "./TeamTag.vue?vue&type=template&id=32417e5c&scoped=true&"
import script from "./TeamTag.vue?vue&type=script&lang=js&"
export * from "./TeamTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32417e5c",
  null
  
)

export default component.exports